import { render } from "./CurrentLoan.vue?vue&type=template&id=7ad8a27d&scoped=true"
import script from "./CurrentLoan.vue?vue&type=script&lang=js"
export * from "./CurrentLoan.vue?vue&type=script&lang=js"

import "./CurrentLoan.vue?vue&type=style&index=0&id=7ad8a27d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad8a27d"]])

export default __exports__